<div class="container-fluid">
  <form #profileForm="ngForm">
    <div class="row" style="padding-top: 15px">
      <h4 class="col-md-8 mt-2" [innerHTML]="'Authentication' | translate"></h4>
      <div class="col-md-4">
        <button
          id="authentication-save"
          type="button"
          (click)="saveMfa()"
          [disabled]="user.mfa !== MFA.NONE"
          [hidden]="!editAuth"
          class="btn btn-primary btn-sm pull-right"
          [innerHTML]="'Enregistrer' | translate"
        ></button>
        <button
          id="authentication-cancel"
          type="button"
          (click)="cancelEditAuth()"
          [hidden]="!editAuth"
          class="btn btn-danger btn-sm pull-right mr-2"
          [innerHTML]="'Annuler' | translate"
        ></button>
        <button
          id="authentication-edit"
          type="button"
          (click)="onEditAuth()"
          [hidden]="editAuth"
          class="btn btn-primary btn-sm pull-right"
          [innerHTML]="'Modifier' | translate"
        ></button>
      </div>
    </div>
    <hr />

    <app-mfa-setup #mfaSetup [(mfa)]="user.mfa" [disabled]="!editAuth" (validated)="onMfaValidated($event)" />

    <hr />

    <h4 class="mt-2 mb-4">{{ 'API' | translate }}</h4>
    <div class="form-row">
      <app-label label="API Key" tooltip="APIKeyTooltip" tooltipPlacement="left" class="col-xl-9" />
      <div class="col-xl-3">
        <div class="input-group">
          <input type="text" [(ngModel)]="apiKey" name="apiKey" [disabled]="true" class="form-control" />
          <div
            *ngIf="hasApiKey"
            class="pointer input-group-append"
            (click)="showKey()"
            ngbTooltip="{{ 'ShowKey' | translate }}"
            placement="top"
            container="body"
          >
            <div class="input-group-text"><i class="icofont icofont-eye"></i></div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col-md-8 mt-2 mb-4">
        <h4>{{ 'ChangPassw' | translate }}</h4>
      </div>
      <div class="col-md-4">
        <button
          type="button"
          (click)="editPassword = true"
          [hidden]="editPassword"
          class="btn btn-primary btn-sm pull-right"
          [innerHTML]="'Modifier' | translate"
        ></button>
        <button
          *ngIf="editPassword"
          type="button"
          (click)="resetPassword()"
          [hidden]="!editPassword"
          class="btn btn-primary btn-sm pull-right"
          [innerHTML]="'Enregistrer' | translate"
          [disabled]="disabledPasswordButton()"
        ></button>
        <button
          type="button"
          (click)="cancelEditPassword()"
          [hidden]="!editPassword"
          class="btn btn-danger btn-sm pull-right mr-2"
          [innerHTML]="'Annuler' | translate"
        ></button>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div class="form-group">
          <label for="old-password" [innerHTML]="'AncienMotDePasse' | translate"></label>
          <input
            id="old-password"
            type="password"
            [(ngModel)]="pswd.ancienPassword"
            name="ancienPpassword"
            class="form-control"
            [disabled]="!editPassword"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="new-password" [innerHTML]="'NouveauMotDePasse' | translate"></label>
          <input
            id="new-password"
            type="password"
            [(ngModel)]="pswd.password"
            name="password"
            class="form-control"
            [ngClass]="{ 'is-invalid': pswd.password && pswd.password.length > 8 && !checkPasswordPattern() }"
            [disabled]="!editPassword"
          />
          @if (pswd.password && pswd.password.length >= 8 && !checkPasswordPattern()) {
            {{ 'invalidPassword' | translate }}
          }
          @if (pswd.password && pswd.password.length >= 8 && checkPasswordPattern()) {
            {{ 'validPassword' | translate }}
          }
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label for="rewrite-new-password" [innerHTML]="'ConfirmationNouveauMotdePasse' | translate"></label>
          <input
            id="rewrite-new-password"
            type="password"
            [(ngModel)]="pswd.password2"
            name="password2"
            class="form-control"
            [ngClass]="{ 'is-invalid': pswd.password !== pswd.password2 }"
            [disabled]="!editPassword"
          />
          <div *ngIf="editPassword">
            <div *ngIf="pswd.password == pswd.password2; else passwordNot">
              <small [hidden]="pswd.password == undefined || pswd.password2 == undefined">
                {{ 'PasswordsOK' | translate }}
              </small>
            </div>
            <ng-template #passwordNot>
              <small class="text-danger">{{ 'PasswordsNOK' | translate }}</small>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="editPassword" class="row">
      <div class="col-md-12 form-group">
        {{ 'PasswordRestrictions' | translate }}
      </div>
    </div>
  </form>
</div>
